(function () {
  function initTestimonialsNative(root) {
    var track = root.querySelector('[data-testimonials-track]');
    var dotsWrap = root.querySelector('[data-testimonials-dots]');
    if (!track) return;

    var items = Array.prototype.slice.call(track.querySelectorAll('.testimonials-native__item'));
    if (!items.length) return;

    var dots = dotsWrap
      ? Array.prototype.slice.call(dotsWrap.querySelectorAll('.testimonials-native__dot'))
      : [];

    function setActiveDot(index) {
      if (!dots.length || index < 0) return;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    // Video playback: force restart on 'ended' since the native `loop`
    // attribute is unreliable on some mobile browsers once a video has
    // been paused/resumed by the browser's own visibility throttling.
    // Also explicitly pause/play based on scroll visibility so a video
    // that finished off-screen restarts cleanly when swiped back into
    // view, rather than staying stuck on its last frame.
    items.forEach(function (item) {
      var video = item.querySelector('video.testimonials-native__media');
      if (!video) return;
      video.muted = true;
      video.playsInline = true;
      video.addEventListener('ended', function () {
        video.currentTime = 0;
        var playPromise = video.play();
        if (playPromise && playPromise.catch) playPromise.catch(function () {});
      });
    });

    var mediaObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target.querySelector('video.testimonials-native__media');
          if (video) {
            if (entry.intersectionRatio >= 0.6) {
              var playPromise = video.play();
              if (playPromise && playPromise.catch) playPromise.catch(function () {});
            } else {
              video.pause();
            }
          }

          if (entry.intersectionRatio < 0.6) return;
          setActiveDot(items.indexOf(entry.target));
        });
      },
      { root: track, threshold: [0.6] }
    );

    items.forEach(function (item) {
      mediaObserver.observe(item);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-testimonials-native]').forEach(initTestimonialsNative);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-testimonials-native]');
    if (section) initTestimonialsNative(section);
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) initAll();
  });
})();